// @ts-nocheck
import React, { useContext, useEffect, useState } from 'react';
import { Form, Row, Col, Input, Switch, Button, Modal, InputNumber } from 'antd';
import { SaveOutlined, RollbackOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';

import Message from 'shared_components/message';
import { createPaymentTermAPI, getPaymentTermNameAPI, searchPaymentTermAPI, updatePaymentTermsAPI } from 'services/lookup_table/payment_terms';
import { createVatInputAPI, getVatInputAPI, searchVatInputAPI, updateVatInputAPI } from 'services/lookup_table/vat_input';
import { createStatusAPI, getStatusAPI, searchStatusAPI, updateStatusAPI } from 'services/lookup_table/status';
import { createUnitsAPI, getUnitsAPI, searchUnitsAPI, updateUnitsAPI } from 'services/lookup_table/units';
import { createCurrencyAPI, getCurrencyAPI, searchCurrencyAPI, updateCurrencyAPI } from 'services/lookup_table/currency';
import { createBankAPI, getBankAPI, searchBankAPI, updateBankAPI } from 'services/lookup_table/bank';
import { createPaymentMethodAPI, getPaymentMethodAPI, searchPaymentMethodAPI, updatePaymentMethodAPI } from 'services/lookup_table/payment_method';
import { createEwtAPI, getEwtAPI, searchEwtAPI, updateEwtAPI } from 'services/lookup_table/ewt';
import { fetchMessageListAPI } from 'services/shared/fetchLovList';
import { formatValueOnChange } from 'utils/helper';
import { UserAccessContext } from 'context/userAccess';

const { TextArea } = Input;

const AddLookupDetails = (props) => {
    const { userAccess } = useContext(UserAccessContext);
    const updateRight = userAccess['lkpSetup'].update;

    const [form] = Form.useForm();
    const { drawerClose, refreshTblData, setData } = props;
    const lookupDetProps = ( props.tableData === undefined ? '' : props.tableData )
    const isEditting = (props.tableData === undefined ? false : true);
    const [checkVal, setCheckVal] = useState(false);
    const [lookupName, setLookupName] = useState('');
    const [desc, setDesc] = useState('');
    const [usedBy, setUsedBy] = useState('');
    const [messagesList, setMessagesList] = useState([]);
    const [allDisabled, setAllDisabled] = useState(false)

    useEffect(()=> {
        if(isEditting){
            if(updateRight === 'TRUE'){
                setAllDisabled(false)
            }else{
                setAllDisabled(true)
            }
        }

        if(props.lookupDet === 'PAYMENT TERM'){
            setLookupName(lookupDetProps.term_name)
            setDesc(lookupDetProps.term_desc)
        }
        
        if(props.lookupDet === 'VAT INPUT'){
            setLookupName(lookupDetProps.vat_input_name)
            setDesc(lookupDetProps.vat_input_desc)
        }
        
        if(props.lookupDet === 'STATUS'){
            setLookupName(lookupDetProps.status_name)
            setDesc(lookupDetProps.status_desc)
            setUsedBy(lookupDetProps.used_by)
        }
        
        if(props.lookupDet === 'UNIT'){
            setLookupName(lookupDetProps.unit_name)
            setDesc(lookupDetProps.unit_desc)
        }
        
        if(props.lookupDet === 'CURRENCY'){
            setLookupName(lookupDetProps.currency_code)
            setDesc(lookupDetProps.currency_desc)
        }
        
        if(props.lookupDet === 'BANK'){
            setLookupName(lookupDetProps.bank_name)
            setDesc(lookupDetProps.bank_desc)
        }
        
        if(props.lookupDet === 'PAYMENT METHOD'){
            setLookupName(lookupDetProps.payment_method_name)
            setDesc(lookupDetProps.payment_method_desc)
        }
        
        if(props.lookupDet === 'EWT'){
            setLookupName(lookupDetProps.ewt_percent)
            setDesc(lookupDetProps.ewt_desc)
        }

        form.resetFields();
    }, [lookupDetProps, lookupName, desc]);

    useEffect(()=> {
        form.resetFields();
    }, [props.onCloseDrawer]);

    useEffect(()=> {
        getData();
    }, [])

    async function getData(){
        const messages = await fetchMessageListAPI();
        setMessagesList(messages);

        //test loader spin
        // if(messages){
        //     setLoading(false);
        // };
    };

    const loggedinUser = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));

    const checkLookupDet = (value) =>{
        switch(value){
            case "EWT":
                return 'EWT %';
            case "UNIT":
                return value + " CODE";
            case "CURRENCY":
                return value + " CODE";
            default:
                return value + " NAME";
        };
    }

    function handleSubmit(formValues){
        const m0003 = messagesList.filter((items) => items.message_code === 'M0003');
        const m0033 = messagesList.filter((items) => items.message_code === 'M0033');

        if(checkVal){
            Message.error({ message: m0033[0].message_display });
        }else{
            Modal.confirm({
                title: m0003[0].message_title,
                icon: <ExclamationCircleOutlined />,
                content: m0003[0].message_display,
                okText: 'YES',
                cancelText: 'NO',
                onOk: ()=>{
                    handleConfirm(formValues);
                }
            });
        }
    };

    async function handleConfirm(formValues){
        const userID = loggedinUser.userID;
        const m0031 = messagesList.filter((items) => items.message_code === 'M0031');
        const m0032 = messagesList.filter((items) => items.message_code === 'M0032');
        try {
            if(props.lookupDet === "PAYMENT TERM"){
                if(isEditting){
                    const res = await updatePaymentTermsAPI(formValues, lookupDetProps.term_id, userID);
                    if(res.data.term_id !== undefined){
                        Message.success({ message: m0032[0].message_display });
                    }else{
                        Message.error({ message: 'Payment Term Error: Not Updated' });
                    }
                    const response = await searchPaymentTermAPI()
                    setData(response);
                    
                }else{
                    const res = await createPaymentTermAPI(formValues, userID);
                    if(res.data.term_id !== undefined){
                        Message.success({ message: m0031[0].message_display });
                    }else{
                        Message.error({ message: 'Payment Term Error: Not Created' });
                    }
                }
            }
            
            if(props.lookupDet === "VAT INPUT"){
                if(isEditting){
                    const res = await updateVatInputAPI(formValues, lookupDetProps.vat_input_id, userID);
                    if(res.data.vat_input_id !== undefined){
                        Message.success({ message: 'Vat Input Successfully Updated' });
                    }else{
                        Message.error({ message: 'Vat Input Error: Not Updated' });
                    }
                    const response = await searchVatInputAPI()
                    setData(response);
                    
                }else{
                    const res = await createVatInputAPI(formValues, userID);
                    if(res.data.vat_input_id !== undefined){
                        Message.success({ message: 'Vat Input Successfully Created' });
                    }else{
                        Message.error({ message: 'Vat Input Error: Not Created' });
                    }
                }
            }
            
            if(props.lookupDet === "STATUS"){
                if(isEditting){
                    const res = await updateStatusAPI(formValues, lookupDetProps.status_id, userID);
                    if(res.data.status_id !== undefined){
                        Message.success({ message: 'Status Successfully Updated' });
                    }else{
                        Message.error({ message: 'Status Error: Not Updated' });
                    }
                    const response = await searchStatusAPI()
                    setData(response);
                    
                }else{
                    const res = await createStatusAPI(formValues, userID);
                    if(res.data.status_id !== undefined){
                        Message.success({ message: 'Status Successfully Created' });
                    }else{
                        Message.error({ message: 'Status Error: Not Created' });
                    }
                }
            }
            
            if(props.lookupDet === "UNIT"){
                if(isEditting){
                    const res = await updateUnitsAPI(formValues, lookupDetProps.unit_id, userID);
                    if(res.data.unit_id !== undefined){
                        Message.success({ message: 'Unit Successfully Updated' });
                    }else{
                        Message.error({ message: 'Unit Error: Not Updated' });
                    }
                    const response = await searchUnitsAPI()
                    setData(response);
                    
                }else{
                    const res = await createUnitsAPI(formValues, userID);
                    if(res.data.unit_id !== undefined){
                        Message.success({ message: 'Unit Successfully Created' });
                    }else{
                        Message.error({ message: 'Unit Error: Not Created' });
                    }
                }
            }
            
            if(props.lookupDet === "CURRENCY"){
                if(isEditting){
                    const res = await updateCurrencyAPI(formValues, lookupDetProps.currency_id, userID);
                    if(res.data.currency_id !== undefined){
                        Message.success({ message: 'Currency Successfully Updated' });
                    }else{
                        Message.error({ message: 'Currency Error: Not Updated' });
                    }
                    const response = await searchCurrencyAPI()
                    setData(response);
                    
                }else{
                    const res = await createCurrencyAPI(formValues, userID);
                    if(res.data.currency_id !== undefined){
                        Message.success({ message: 'Currency Successfully Created' });
                    }else{
                        Message.error({ message: 'Currency Error: Not Created' });
                    }
                }
            }
            
            if(props.lookupDet === "BANK"){
                if(isEditting){
                    const res = await updateBankAPI(formValues, lookupDetProps.bank_id, userID);
                    if(res.data.bank_id !== undefined){
                        Message.success({ message: 'Bank Successfully Updated' });
                    }else{
                        Message.error({ message: 'Bank Error: Not Updated' });
                    }
                    const response = await searchBankAPI()
                    setData(response);
                    
                }else{
                    const res = await createBankAPI(formValues, userID);
                    if(res.data.bank_id !== undefined){
                        Message.success({ message: 'Bank Successfully Created' });
                    }else{
                        Message.error({ message: 'Bank Error: Not Created' });
                    }
                }
            }
            
            if(props.lookupDet === "PAYMENT METHOD"){
                if(isEditting){
                    const res = await updatePaymentMethodAPI(formValues, lookupDetProps.payment_method_id, userID);
                    if(res.data.payment_method_id !== undefined){
                        Message.success({ message: 'Payment Method Successfully Updated' });
                    }else{
                        Message.error({ message: 'Payment Method Error: Not Updated' });
                    }
                    const response = await searchPaymentMethodAPI()
                    setData(response);
                    
                }else{
                    const res = await createPaymentMethodAPI(formValues, userID);
                    if(res.data.payment_method_id !== undefined){
                        Message.success({ message: 'Payment Method Successfully Created' });
                    }else{
                        Message.error({ message: 'Payment Method Error: Not Created' });
                    }
                }
            }
            
            if(props.lookupDet === "EWT"){
                if(isEditting){
                    const res = await updateEwtAPI(formValues, lookupDetProps.ewt_id, userID);
                    if(res.data.ewt_id !== undefined){
                        Message.success({ message: 'EWT Successfully Updated' });
                    }else{
                        Message.error({ message: 'EWT Error: Not Updated' });
                    }
                    const response = await searchEwtAPI()
                    setData(response);
                    
                }else{
                    const res = await createEwtAPI(formValues, userID);
                    if(res.data.ewt_id !== undefined){
                        Message.success({ message: 'EWT Successfully Created' });
                    }else{
                        Message.error({ message: 'EWT Error: Not Created' });
                    }
                }
            }
                    
            drawerClose(false);
            refreshTblData(true);
            form.resetFields();

        } catch (error) {
            Message.error(error);
        }
    };

    function handleBack(){
        const m0008 = messagesList.filter((items) => items.message_code === 'M0008');
        const checkBackVal = form.getFieldsValue(null, meta => meta.touched);
        const backArr = Object.values(checkBackVal);

        if(backArr.length > 0 ){
            const m0008Title = m0008[0].message_title === undefined ? '' : m0008[0].message_title;
            const m0008Message = m0008[0].message_display === undefined ? 'Changes will be cancelled' : m0008[0].message_display;

            Modal.confirm({
                title: m0008Title,
                icon: <ExclamationCircleOutlined />,
                content: m0008Message,
                okText: 'YES',
                cancelText: 'NO',
                onOk: ()=>{  
                    form.resetFields();
                    drawerClose(false);
                }
            });
        }else{
            form.resetFields();
            drawerClose(false);
        }
    };
    
    const statusOnChange = (checked)=>{
        console.log("status", checked);
    };

    const handleOnBlur = async (e)=>{
        const m0033 = messagesList.filter((items) => items.message_code === 'M0033');
        try {
            let lookupNameOnBlur = [];
            if(props.lookupDet === "PAYMENT TERM"){
                lookupNameOnBlur = await getPaymentTermNameAPI(e.target.value);
            }

            if(props.lookupDet === "VAT INPUT"){
                lookupNameOnBlur = await getVatInputAPI(e.target.value);
            }

            // if(props.lookupDet === "STATUS"){
            //     lookupNameOnBlur = await getStatusAPI(e.target.value);
            // }

            if(props.lookupDet === "UNIT"){
                lookupNameOnBlur = await getUnitsAPI(e.target.value);
            }

            if(props.lookupDet === "CURRENCY"){
                lookupNameOnBlur = await getCurrencyAPI(e.target.value);
            }

            if(props.lookupDet === "BANK"){
                lookupNameOnBlur = await getBankAPI(e.target.value);
            }

            if(props.lookupDet === "PAYMENT METHOD"){
                lookupNameOnBlur = await getPaymentMethodAPI(e.target.value);
            }

            if(props.lookupDet === "EWT"){
                if(e.target.value === ''){
                    lookupNameOnBlur=[];
                }else{
                    lookupNameOnBlur = await getEwtAPI(e.target.value);
                }
            }
            
            if(lookupNameOnBlur.length > 0){
                setCheckVal(true);
                Message.error({ message: m0033[0].message_display });
            }else{
				setCheckVal(false);
			}
        } catch (error) {
            console.log(`${props.lookupDet} error`, error);
            Message.error(error);
        }
    }

    const handleNameOnChange = (e)=> {
        if(props.lookupDet === "EWT"){
            const ewt = e.target.value === '' ? null : e.target.value;
            const formatedValue = formatValueOnChange(ewt, 'numeric');
            form.setFieldsValue({lookupName: formatedValue});
        }
    }
    
    return(
        <Form
            form={form}
            layout="vertical"
            onFinish={handleSubmit}
        >
            <Row gutter ={[8 , 1]} justify="end">                        
                <Col>
                    <Form.Item name="isActive"  initialValue={(isEditting) ? lookupDetProps.is_active : true}>
                        <Switch checkedChildren='Active' unCheckedChildren='Inactive' onChange={statusOnChange}
                        defaultChecked={(isEditting) ? lookupDetProps.is_active : true} 
                        disabled={allDisabled}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[8, 1]} justify="space-around" align="top">
                <Col span={24} >
                    <Form.Item
                        label={checkLookupDet(props.lookupDet)}
                        name="lookupName"
                        initialValue={(isEditting) ? lookupName : ''}
                        rules={[ {required: true, message: "Required field"} ]}
                    >
                        <Input type={'text'} 
                            className='inv-input-uppercase'
                            placeholder={(props.lookupDet==='EWT') ? 'EWT' : checkLookupDet(props.lookupDet)}
                            maxLength={50}
                            onChange={handleNameOnChange}
                            onBlur={handleOnBlur}
                            disabled={allDisabled}
                        />
                    </Form.Item>
                </Col>
            </Row>
            <Row gutter={[8, 1]} justify="space-around" align="top">
                <Col span={24} >
                    <Form.Item
                        label="DESCRIPTION"
                        name="description"
                        initialValue={(isEditting) ? desc : ''}
                    >
                        <TextArea 
                            className='inv-input-uppercase'
                            placeholder='DESCRIPTION'
                            maxLength={200}
                            disabled={allDisabled}
                        />
                    </Form.Item>
                </Col>
            </Row>
            {(props.lookupDet!=='TEST')
                ?   <Row gutter ={[8 , 1]} justify='end' >
                        <Col span={8}>
                            <Form.Item label="SORT" name="sort" >
                                <InputNumber
                                    style={{width:'70%'}}
                                    type="number"
                                    disabled={allDisabled}
                                />
                            </Form.Item>
                        </Col>
                        <Col style={{padding:'20px 0 0 0'}}>
                            <Form.Item name="isDefault"  initialValue={(isEditting) ? lookupDetProps.is_active : true}>
                                <Switch checkedChildren='Default' unCheckedChildren='Default' onChange={statusOnChange}
                                disabled={allDisabled}
                                // defaultChecked={(isEditting) ? lookupDetProps.is_active : true} 
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                :   <></>
            }
            {(props.lookupDet==='STATUS')
                ?   <Row gutter={[8, 1]} justify="space-around" align="top">
                        <Col span={24} >
                            <Form.Item
                                label="USED BY"
                                name="usedBy"
                                initialValue={(isEditting) ? usedBy : ''}
                            >
                                <Input type={'text'} 
                                    className='inv-input-uppercase'
                                    placeholder='USED BY'
                                    disabled={allDisabled}
                                />
                            </Form.Item>
                        </Col>
                    </Row>
                :   <></>
            }
            <Row gutter={[8, 1]} justify='end'>
                <Col style={{marginTop:50}}>
                    <Form.Item>                                
                        <Button 
                            className="inv-button-right" 
                            type="primary" 
                            onClick={handleBack}
                            icon={<RollbackOutlined />}
                        >
                            BACK
                        </Button>
                        <Button 
                            className="inv-button" 
                            type="primary" 
                            htmlType='submit'
                            icon={<SaveOutlined />}
                            disabled={allDisabled}
                        >
                            SAVE
                        </Button>
                    </Form.Item>
                </Col>
            </Row>
        </Form>
    )
};
export default AddLookupDetails;